import type { TextareaHTMLAttributes } from 'react';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  helperText?: string;
  error?: string;
}

export default function Textarea({ label, helperText, error, className = '', id, rows = 4, style, ...props }: TextareaProps) {
  const textareaId = id || label?.toLowerCase().replace(/\s/g, '-');
  return (
    <div>
      {label && <label htmlFor={textareaId} className="form-label">{label}</label>}
      <textarea
        id={textareaId}
        rows={rows}
        className={`form-textarea ${className}`}
        style={error ? { borderColor: 'var(--red)', ...style } : style}
        aria-invalid={!!error}
        aria-describedby={error ? `${textareaId}-error` : helperText ? `${textareaId}-helper` : undefined}
        {...props}
      />
      {helperText && !error && <p id={`${textareaId}-helper`} className="form-helper">{helperText}</p>}
      {error && <p id={`${textareaId}-error`} className="form-helper form-helper-error" role="alert">{error}</p>}
    </div>
  );
}
